export const RECOVERY_FORM_MESSAGE_VALIDATION_RULES = {
  recoveryMemberIdentifierFormMessage: {
    isRequired: {
      value: true,
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/member-identifier-configuration/RecoveryFormMessageValidationRules.js